export interface IUpload {
    root:string
    path:string;
    file:File;
}

export type TDataTransfer = {
    dataTransfer:DataTransfer
}

export default class DragAndDrop {
    static getFile(root:string, path:string, item:any) : Promise<IUpload> {
        return new Promise(cb => item.file( (file:File) => cb({root, path,file}) ))
    }
    static readDir(dir:any) {
        return new Promise(cb => dir.createReader().readEntries(cb))
    }
    static async collectFile(files:IUpload[], root:string, path:string, item:any) {
        try {
            if (item.isFile) files.push(await DragAndDrop.getFile(root, path, item))
            else if (item.isDirectory) {
                const treeItems = await DragAndDrop.readDir(item)
                await DragAndDrop.collectFiles(files, root, path + item.name + "/", treeItems)
            }
        }catch(e){
            const file = item.getAsFile instanceof Function ? item.getAsFile() : null
            if (file) files.push({root, path, file})
        }
    }
    static async collectFiles(files:IUpload[], root:string, path:string, items:any) {
        const p : Promise<any>[] = []
        for(let item of items) p.push(DragAndDrop.collectFile(files, root, path, item))
        await Promise.all(p)
        return files
    }    
    static isDataTransfer(e:any) : e is TDataTransfer {
        return "dataTransfer" in e
    }
    static async getFiles(root:string, e:TDataTransfer|HTMLInputElement) {
        const files : IUpload[] = []
        const p:Promise<any>[] = []
        if (this.isDataTransfer(e)) {
            for(const item of e.dataTransfer.items) {
                if (item.kind!="file") continue;
                const tree = item.webkitGetAsEntry()
                p.push(DragAndDrop.collectFile(files, root, "", tree))
            }
            await Promise.all(p)
        }else if (e.files?.length) {
            const file = e.files[0]
            files.push({root, path:"", file})
        }
        return files
    }
}